/* eslint-disable no-param-reassign, max-params */
import { createStore } from "vuex";
import artworkModule from "./artwork-module";
import checkoutModule from "./checkout-module";
import deliveryModule from "./delivery-module";
import productModule from "./product-module";
import loadingModule from "./loading-module";
import errorsModule from "./errors-module";
import creationModule from "./creation-module";

const availablePages = ["loading", "builder"];

const initialState = {
  currentPage: "loading",
  config: {}
};

const store = createStore({
  state() {
    return { ...initialState };
  },

  getters: {
    currentPage: state => state.currentPage,
    config: state => state.config
  },

  mutations: {
    setCurrentPage(state, value) {
      if (availablePages.includes(value)) {
        state.currentPage = value;
      }
    },
    setConfig(state, value) {
      state.config = value;
    }
  },

  modules: {
    artwork: artworkModule,
    checkout: checkoutModule,
    delivery: deliveryModule,
    product: productModule,
    loading: loadingModule,
    errors: errorsModule,
    creation: creationModule
  }
});

export default store;
